// extracted by mini-css-extract-plugin
module.exports = {"container":"common-signup_container__UoJXJ","logo":"common-signup_logo__3n8ec","form":"common-signup_form__26hcP","copy":"common-signup_copy__2gxDg"};